import { Injectable } from '@angular/core';
import { QueueService } from 'src/core/queue/domain/queue.service';
import { SessionService } from 'src/core/session/domain/session.service';
import { DeviceService } from 'src/core/device/device.service';
import { ApiService } from 'src/core/api/domain/api.service';
import { LostChangesReporter } from 'src/core/presence/domain/lost-changes-reporter';
import { LostChangesReport } from 'src/core/presence/domain/lost-changes-report';
import { ReportLostChangesRequest } from './report-lost-changes-request';

@Injectable({
  providedIn: 'any',
})
export class ReportLostChanges {
  constructor(
    private readonly queueService: QueueService,
    private readonly sessionService: SessionService,
    private readonly deviceService: DeviceService,
    private readonly apiService: ApiService,
    private readonly lostChangesReporter: LostChangesReporter
  ) {}

  /**
   * Synchronous on purpose: presence control runs it between deciding to log out and announcing the logout,
   * and a synchronization pass must not get the chance to start in between.
   */
  execute(request: ReportLostChangesRequest): void {
    const lostElements = this.queueService.getVisibleElements();
    if (lostElements.length === 0) {
      return;
    }

    const report = new LostChangesReport(
      this.sessionService.getUser()?.id ?? null,
      this.deviceService.getUuid(),
      this.apiService.currentApi().id,
      request.trigger,
      lostElements
    );
    this.lostChangesReporter.report(report);
  }
}
